import React, { useState } from "react";
import cn from "classnames";
import style from "./common.module.scss";
import CustomDatePicker from "../../shared/date-picker/Date";
import CustomButton from "../../custom/custom-button/CustomButton";
import CalendarIcon from "../../shared/icons/CalendarIcon";
import { numberToFinanceFormat } from "../../../utils";
import { useTranslation } from "react-i18next";
import { useScreenSize } from "../../../hooks/useScreenSize";
import CurrencyDropdown from "./GroupByDropdown/CurrencyDropdown";
import { CURRENCIES } from "../../../mock";

const BasicAnalytics = ({
  startDate,
  setStartDate,
  item,
  endDate,
  setEndtDate,
  currency,
  setCurrency,
  isExpeditor = false,
}) => {
  const { t } = useTranslation();
  const isNoCurrency = currency === "all" || currency === "";

  return (
    <>
      <div className={cn(style.filter, style.filter_pd)}>
        <div className={style.filter_date}>
          <CustomDatePicker
            dateFormat="dd.MM.yyyy"
            placeholderText={t("analytics.pickDate")}
            withBorder
            IconStart={<CalendarIcon />}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showYearNavigation
          />
          <CustomDatePicker
            dateFormat="dd.MM.yyyy"
            placeholderText={t("analytics.pickDate")}
            withBorder
            IconStart={<CalendarIcon />}
            selected={endDate}
            onChange={(date) => setEndtDate(date)}
            showYearNavigation
          />

          <CurrencyDropdown currency={currency} setCurrency={setCurrency} isSideBar={false} />
        </div>
        {/* <CustomButton text="Экспорт" isMain /> */}
      </div>

      <div className={cn(style.metric)}>
        <div className={style.metric_item}>
          <div className={style.metric_title}>{t("analytics.orders")}</div>
          <div className={style.metric_number}>{numberToFinanceFormat(item?.totalOrders)}</div>
        </div>
        <div className={style.metric_item}>
          <div className={style.metric_title}>{t("analytics.completed")}</div>
          <div className={style.metric_number}>{numberToFinanceFormat(item?.completedOrders)}</div>
        </div>
        <div className={style.metric_item}>
          <div className={style.metric_title}>{t("analytics.canceled")}</div>
          <div className={style.metric_number}>{numberToFinanceFormat(item?.canceledOrders)}</div>
        </div>
        <div className={style.metric_item}>
          <div className={style.metric_title}>{t("analytics.onTrip")}</div>
          <div className={style.metric_number}>{numberToFinanceFormat(item?.onTheWayOrders)}</div>
        </div>
      </div>

      {isExpeditor ? (
        <div className={cn(style.metric)}>
          <div className={style.metric_item}>
            <div className={style.metric_title}>{t("analytics.orders")}</div>
            <div className={style.metric_number}>{numberToFinanceFormat(item?.totalSum)}</div>
          </div>
          <div className={style.metric_item}>
            <div className={style.metric_title}>{t("analytics.avgOrderPrice")}</div>
            <div className={style.metric_number} style={isNoCurrency ? { fontSize: "26px" } : {}}>
              {isNoCurrency ? t("analytics.selectCurrency") : numberToFinanceFormat(item?.averageSum ? item?.averageSum : 0)}
            </div>
          </div>
          <div className={style.metric_item}>
            <div className={style.metric_title}>{t("analytics.tenderRequestShare")}</div>
            <div className={style.metric_number}>{numberToFinanceFormat(item?.tender)}%</div>
          </div>
          <div className={style.metric_item}>
            <div className={style.metric_title}>{t("analytics.directAssignmentShare")}</div>
            <div className={style.metric_number}>{numberToFinanceFormat(item?.assigned)}%</div>
          </div>
        </div>
      ) : (
        <div className={style.metric}>
          <div className={style.metric_item}>
            <div className={style.metric_title}>{t("analytics.avgOrderPrice")}</div>
            <div className={style.metric_number} style={isNoCurrency ? { fontSize: "26px" } : {}}>
              {isNoCurrency ? t("analytics.selectCurrency") : numberToFinanceFormat(item?.averageSum, true)}
              {CURRENCIES[currency]?.symbol || ""}
            </div>
          </div>
          <div className={style.metric_item}>
            <div className={style.metric_title}>{t("analytics.distance")}</div>
            <div className={style.metric_number}>
              {numberToFinanceFormat(item?.totalDistance, true)} {t("analytics.distance_metric")}
            </div>
          </div>
        </div>
      )}

      <div className={cn(style.metric__mobile)}>
        <div className={style.metric_item}>
          <div className={style.metric_title}>{t("analytics.orders")}</div>
          <div className={style.metric_number}>{numberToFinanceFormat(item?.totalOrders)}</div>
        </div>
        <div className={style.metric_item}>
          <div className={style.metric_title}>{t("analytics.completed")}</div>
          <div className={style.metric_number}>{numberToFinanceFormat(item?.completedOrders)}</div>
        </div>
        <div className={style.metric_item}>
          <div className={style.metric_title}>{t("analytics.canceled")}</div>
          <div className={style.metric_number}>{numberToFinanceFormat(item?.canceledOrders)}</div>
        </div>
        <div className={style.metric_item}>
          <div className={style.metric_title}>{t("analytics.onTrip")}</div>
          <div className={style.metric_number}>{numberToFinanceFormat(item?.onTheWayOrders)}</div>
        </div>
        <div className={style.metric_item}>
          <div className={style.metric_title}>{t("analytics.avgOrderPrice")}</div>
          <div className={style.metric_number} style={isNoCurrency ? { fontSize: "26px" } : {}}>
            {isNoCurrency ? t("analytics.selectCurrency") : numberToFinanceFormat(item?.averageSum, true)}
            {CURRENCIES[currency]?.symbol || ""}
          </div>
        </div>

        {isExpeditor ? (
          <>
            <div className={style.metric_item}>
              <div className={style.metric_title}>{t("analytics.onTrip")}</div>
              <div className={style.metric_number}>{numberToFinanceFormat(item?.totalSum)}</div>
            </div>
            <div className={style.metric_item}>
              <div className={style.metric_title}>{t("analytics.tenderRequestShare")}</div>
              <div className={style.metric_number}>{numberToFinanceFormat(item?.tender)}%</div>
            </div>
            <div className={style.metric_item}>
              <div className={style.metric_title}>{t("analytics.directAssignmentShare")}</div>
              <div className={style.metric_number}>{numberToFinanceFormat(item?.assigned)}%</div>
            </div>
          </>
        ) : (
          <div className={style.metric_item}>
            <div className={style.metric_title}>{t("analytics.distance")}</div>
            <div className={style.metric_number}>
              {numberToFinanceFormat(item?.totalDistance, true)} {t("analytics.distance_metric")}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BasicAnalytics;
